import { render, staticRenderFns } from "./Pointwave.vue?vue&type=template&id=6f6df9c1"
import script from "./Pointwave.vue?vue&type=script&lang=js"
export * from "./Pointwave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports